export default __webpack_public_path__ + "static/report-content-01-3dd74df22af620287bd85ac68e30393a.png";